/**
 * Layout Registry
 *
 * Central registry for all available pathway layout algorithms.
 * Allows easy switching between different layout types.
 */

import layoutOrganicTree from './organicTree';

export const LAYOUT_TYPES = {
  ORGANIC_TREE: 'organic-tree',
  // Future layouts:
  // RADIAL: 'radial',
  // FORCE_DIRECTED: 'force-directed',
  // HIERARCHICAL: 'hierarchical',
  // TIMELINE: 'timeline',
};

/**
 * Registry mapping layout type to layout function
 */
const layoutRegistry = {
  [LAYOUT_TYPES.ORGANIC_TREE]: layoutOrganicTree,
};

/**
 * Get a layout function by type
 *
 * @param {string} layoutType - Type from LAYOUT_TYPES
 * @returns {Function} Layout function
 */
export function getLayout(layoutType) {
  const layout = layoutRegistry[layoutType];
  if (!layout) {
    console.warn(`Layout type "${layoutType}" not found, using default`);
    return layoutRegistry[LAYOUT_TYPES.ORGANIC_TREE];
  }
  return layout;
}

/**
 * Apply a layout to a set of nodes
 *
 * @param {Array} nodes - Array of node objects
 * @param {string} layoutType - Type from LAYOUT_TYPES
 * @param {Object} config - Optional layout-specific config
 * @returns {Object} {positions: {nodeId: {x, y}}, arrows: [{from, to, path}]}
 */
export function applyLayout(nodes, layoutType = LAYOUT_TYPES.ORGANIC_TREE, config = {}) {
  const layoutFn = getLayout(layoutType);
  return layoutFn(nodes, config);
}

export default {
  LAYOUT_TYPES,
  getLayout,
  applyLayout
};
